import * as React from 'react';
import { useTabs } from './TabContext';

// Components.
import { BaseStyleProps, PanelWrapper } from './Tabs.style';

export interface IPanelProps extends BaseStyleProps {
  /**
   * Unique identifier of the Tab mapped to this
   * panel.
   */
  label: string;

  children?: React.ReactNode;

  id?: string
}

/**
 * Individual Tab panel.
 */
const Panel: React.FC<IPanelProps> = ({ label, children, id, ...props }) => {
  const { activeTab } = useTabs();
  return (
    <PanelWrapper
      role="tabpanel"
      id={id}
      display={activeTab === label ? 'block' : 'none'}
      hidden={activeTab !== label}
      {...props}
    >
      {children}
    </PanelWrapper>
  );
};

export default Panel;
